import { formatDate, IconDownload, IconLoader } from '@ui/src';
import {
  Agreement,
  AgreementClientType,
  AgreementStatus,
  AgreementType,
} from '../types';

import cn from '../styles.module.css';

export const getAgreementTypeName = (type: AgreementType) => {
  let agreementTypeName: string;

  switch (type) {
    case AgreementType.GENERAL_T_AND_CS:
      agreementTypeName = 'General T&Cs';
      break;
    case AgreementType.PRIVACY_NOTICE:
      agreementTypeName = 'Privacy Notice';
      break;
    case AgreementType.ANNEX_1:
      agreementTypeName = 'Annex 1';
      break;
    case AgreementType.ANNEX_2:
      agreementTypeName = 'Annex 2';
      break;
    case AgreementType.ANNEX_3:
      agreementTypeName = 'Annex 3';
      break;
    case AgreementType.ANNEX_4:
      agreementTypeName = 'Annex 4';
      break;
    case AgreementType.ANNEX_5:
      agreementTypeName = 'Annex 5';
      break;
    case AgreementType.ANNEX_6:
      agreementTypeName = 'Annex 6';
      break;
    case AgreementType.ANNEX_7:
      agreementTypeName = 'Annex 7';
      break;
    case AgreementType.ANNEX_8:
      agreementTypeName = 'Annex 8';
      break;
    default:
      agreementTypeName = type;
      break;
  }

  return agreementTypeName;
};

const getClientTypeName = (type: AgreementClientType) => {
  let clientTypeName: string;

  switch (type) {
    case AgreementClientType.COMPANY_OFFICIAL:
      clientTypeName = 'Company Official';
      break;
    case AgreementClientType.CORPORATE:
      clientTypeName = 'Corporate';
      break;
    case AgreementClientType.INDIVIDUAL:
      clientTypeName = 'Individual';
      break;
    default:
      clientTypeName = type;
      break;
  }

  return clientTypeName;
};

const formatAgreementsList = (
  list: Agreement[],
  getAgreementFile: (id: string) => void,
  downloadFile: string,
  fileDownloadInProgress: boolean,
): Agreement[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};

    render.type = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {getAgreementTypeName(item.type)}
      </div>
    );
    render.client = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {getClientTypeName(item.client)}
      </div>
    );
    render.status = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {result.status === AgreementStatus.ARCHIVED ? 'Archived' : 'Published'}
      </div>
    );
    render.createdAt = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {formatDate(result.createdAt)}
      </div>
    );

    render.startAt = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {result.startAt ? formatDate(result.startAt) : '-'}
      </div>
    );

    render.version = (
      <div
        className={
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        }
      >
        {result.version}
      </div>
    );

    render.archivedAt = (
      <div
        className={`${
          result.status === AgreementStatus.ARCHIVED ? cn.archived : ''
        } ${cn.dateArchivated}`}
      >
        <span>{result.archivedAt ? formatDate(result.archivedAt) : '-'}</span>
        <button
          type="button"
          className={cn.agreementDownloadButton}
          onClick={() => getAgreementFile(item.id)}
          disabled={fileDownloadInProgress}
        >
          {fileDownloadInProgress && downloadFile === item.id ? (
            <IconLoader width={16} height={16} />
          ) : (
            <IconDownload />
          )}
        </button>
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAgreementsList;
